import React, { Fragment, useEffect, useRef } from 'react';
import createPanZoom from 'panzoom';
import SliderHandle from './SliderHandle';
import ImageCompareSlider from './ImageCompareSlider';
import ZoomPercentage from './ZoomPercentage';
import SizeLabels from './SizeLabels';

const ImageCompareController = props => {
	const { file, sliderSelector } = props;
	const subscribers = [];
	const subscribersForZoom = [];
	const panzoomRef = useRef();
	let scaleAt100 = 100;
	function reportProgress(progress) {
		subscribers.forEach(fn => {
			if (panzoomRef.current) {
				const container = document.querySelector('.wrapper');
				const transform = panzoomRef.current.getTransform();
				const prog = Math.max(0, Math.min(1,
					(progress.x - transform.x) / (container.clientWidth * transform.scale)));
				fn(prog);
			}
		});
	}
	function subscribeForProgress(fn) {
		if (typeof fn === 'function' && !subscribers.includes(fn)) {
			subscribers.push(fn);
		}
	}
	function subscribeForZoom(fn) {
		if (typeof fn === 'function' && !subscribers.includes(fn)) {
			subscribersForZoom.push(fn);
		}
	}
	function onZoom(panZoomObject) {
		subscribersForZoom.forEach(fn => {
			const transform = panZoomObject.getTransform();
			fn(Math.round((transform.scale / scaleAt100) * 100));
		});
	}
	useEffect(() => {
		const container = document.querySelector('#panzoom');
		// const screenWidth = document.body.clientWidth;
		// const screenHeight = document.body.clientHeight;
		const screenHeight = document.querySelector('.wrapper').clientHeight;
		const screenWidth = document.querySelector('.wrapper').clientWidth;
		console.log(screenWidth);
		// panzoomRef.current = createPanZoom(container, { zoomSpeed: 0.03 });
		// it seems sometimes on firstrun, element.clientHeight is not accurate.
		// most probably becoase panzoom is not complete
		// add a little delay
		// panzoomRef.current.on('zoom', onZoom);
		// setTimeout(() => {
		// 	if (file.displayWidth <= screenWidth) {
		// 		// image is stretched
		// 		const scale = (screenWidth - file.displayWidth) / screenWidth;
		// 		const x = (screenWidth - file.displayWidth) / 2;
		// 		let y = 0;
		// 		if (file.displayHeight < screenHeight) {
		// 			y = (screenHeight - file.displayHeight) / 2;
		// 		}
		// 		scaleAt100 = 1 - scale;
		// 		panzoomRef.current.zoomTo(0, 0, scaleAt100);
		// 		panzoomRef.current.moveTo(x, y);
		// 	} else {
		// 		// image is shrinked
		// 		const scale = (file.displayWidth - screenWidth) / screenWidth;
		// 		const x = (screenWidth - file.displayWidth) / 2;
		// 		scaleAt100 = 1 + scale;
		// 		panzoomRef.current.zoomTo(0, 0, scaleAt100);
		// 		panzoomRef.current.moveTo(x, 0);
		// 	}
		// }, 30);
	}, []);
	return (
		<Fragment>
			<SliderHandle selector={sliderSelector} reportProgress={reportProgress} />
			<div id="panzoom">
				<ImageCompareSlider
					before={file.originalFilePath}
					after={file.url}
					subscribeForProgress={subscribeForProgress}
				/>
			</div>
			{/* <ZoomPercentage subscribeForZoom={subscribeForZoom} />
			<SizeLabels size={file.sizeFormatted} compressed={file.compressedSizeFormatted} /> */}
		</Fragment>
	);
};

export default ImageCompareController;



// WEBPACK FOOTER //
// ./src/components/image-compare/ImageCompareController.js